import { TotalAmountRubloLireCard } from "@/erp/clientes/fibra-optica/shared/components/form/rubros";
import { BucketAwtENUM, EstadoFactibilidadCorporativaENUM, gridSizeConst3, gridSizeMdLg12, gridSizeMdLg6, ROUTER_PATHS, useCheckPermissionsArray, useLoaders } from "@/shared";
import { useFetchGetByIdfactibilidadCorporativos, useFetchPutFactibilidadCorporativo } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { DropzoneFiles, SampleTable } from "@/shared/components/ui";
import { AlertSeverityEnum, CategoriaFCorporativaEnum } from "@/shared/interfaces";
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
import { Button, Grid, Tooltip, Typography } from "@mui/material";
// import copy from "copy-to-clipboard";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { useUiStore } from "@/store/ui";
import { PermissionsEnum } from "@/auth/interfaces";
import { MaterialTransferidoInventarioCorporativo } from "@/erp/contabilidad/clientes-corporativos/pages/ClientesCoorporativosSave";
// import { usePlanStore } from "@/store/erp/system-settings/plan.store";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import dayjs from "dayjs";
import { fetchPutPreventaCorporativo } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import { CondicionVentaCorporativa } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import { useForm } from "react-hook-form";

export default function SolucionCosteadaVer() {
  /// IMPORTANT
  useCheckPermissionsArray([
    PermissionsEnum.api_view_factibilidadcoorporativa
  ]);
  const returnUrl = ROUTER_PATHS.ventasCorporativas.solucionCosteadaCorporativoNav;
  const { idsolucioncosteada } = useParams();
  const navigate = useNavigate()

  const [openUploadDocuments, setOpenUploadDocuments] = useState<boolean>(false);
  const [utltimaCorreccion, setUtltimaCorreccion] = useState<any>({});
  const [allItemsCosteados, setAllItemsCosteados] = useState<MaterialTransferidoInventarioCorporativo[]>([]);
  // const [docAnexo1, setDocAnexo1] = useState<File | null>(null)
  // const [docAnexo2, setDocAnexo2] = useState<File | null>(null)


  const form = useForm<any>({
  })
  const form2 = useForm<any>({
  })

  ///GLOBALS
  const setAlert = useUiStore(s => s.setAlert);
  const clearSelectedItems = useMaterialesUtilizadosStore(
    s => s.clearSelectedItems
  );

  ///QUERIES
  const {
    data: dataSolucionCosteada,
    isLoading: isfcSolucionCosteada,
    // isRefetching: isRefetchingFactCoorporativa,
  } = useFetchGetByIdfactibilidadCorporativos(idsolucioncosteada!)

  const {
    mutateAsync: updateFCorporativa
    // isRefetching: isRefetchingFactCoorporativa,
  } = useFetchPutFactibilidadCorporativo({
    navigate: navigate,
    returnUrl: returnUrl
  })

  const {
    mutateAsync: mutateAsyncPutPreventaCorporativo
  } = fetchPutPreventaCorporativo({
    enableSuccessAlert: true,
    navigate: navigate
  })


  /// HANDLERS
  const onSend = () => {
    updateFCorporativa({
      id_factibilidad_coorporativa: dataSolucionCosteada?.data.id_factibilidad_coorporativa,
      factibilidad_enviada: true
    })
    setAlert(true, 'Solución costeada enviada para agendamiento.', AlertSeverityEnum.success);
  }
  const rechazarSolucion = () => {
    updateFCorporativa({
      id_factibilidad_coorporativa: dataSolucionCosteada?.data.id_factibilidad_coorporativa,
      estado_factibilidad: EstadoFactibilidadCorporativaENUM.CANCELADO
    })
    setAlert(true, 'Solución costeada rechazada.', AlertSeverityEnum.success);
  }
  const solicitarAprobacionInventario = () => {
    updateFCorporativa({
      id_factibilidad_coorporativa: dataSolucionCosteada?.data.id_factibilidad_coorporativa,
      estado_factibilidad: EstadoFactibilidadCorporativaENUM.EN_REVISION,
      aprobado_supervisor: true,
      revisado_supervisor: true,
    })
    setAlert(true, 'Solución costeada enviada para aprobación por inventario.', AlertSeverityEnum.success);
  }


  //FUNCTION TABLES
  const calcTotal = (): string => {
    // const onlyVALORESPLAN = allItemsCosteados?.filter((x: MaterialTransferidoInventarioCorporativo) => x.categoria_fcorporativa == CategoriaFCorporativaEnum.VALORESPLAN)
    // const onlySERVICIOSADICIONALES = allItemsCosteados?.filter((x: MaterialTransferidoInventarioCorporativo) => x.categoria_fcorporativa == CategoriaFCorporativaEnum.SERVICIOSADICIONALES)
    return allItemsCosteados
      .filter(x => x.categoria_fcorporativa != CategoriaFCorporativaEnum.MATERIALESEQUIPOS)
      .reduce(
        (acc, item) =>
          acc +
          +(item.precioUnitario || 0) *
          +(item.cantidad || 0) *
          +(1 + ((item.incremento || 0) / 100) || 0) *
          (+(item.ivaValue || 0) / 100 + 1),
        0
      )
      .toFixed(2);
  };

  const calcSubTotal = (): string => {
    // const onlyVALORESPLAN = allItemsCosteados?.filter((x: MaterialTransferidoInventarioCorporativo) => x.categoria_fcorporativa == CategoriaFCorporativaEnum.VALORESPLAN)
    // const onlySERVICIOSADICIONALES = allItemsCosteados?.filter((x: MaterialTransferidoInventarioCorporativo) => x.categoria_fcorporativa == CategoriaFCorporativaEnum.SERVICIOSADICIONALES)

    return allItemsCosteados
      .filter(x => x.categoria_fcorporativa != CategoriaFCorporativaEnum.MATERIALESEQUIPOS)
      .reduce(
        (acc, item) =>
          acc +
          +(item.precioUnitario || 0) *
          +(item.cantidad || 0) *
          +(1 + ((item.incremento || 0) / 100) || 0),
        0
      )
      .toFixed(2);

  };

  const calcTotalTaxes = (): string => {
    // const onlyVALORESPLAN = allItemsCosteados?.filter((x: MaterialTransferidoInventarioCorporativo) => x.categoria_fcorporativa == CategoriaFCorporativaEnum.VALORESPLAN)
    // const onlySERVICIOSADICIONALES = allItemsCosteados?.filter((x: MaterialTransferidoInventarioCorporativo) => x.categoria_fcorporativa == CategoriaFCorporativaEnum.SERVICIOSADICIONALES)

    return allItemsCosteados
      .filter(x => x.categoria_fcorporativa != CategoriaFCorporativaEnum.MATERIALESEQUIPOS)
      .reduce(
        (acc, item) =>
          acc +
          +(item.precioUnitario || 0) *
          +(item.cantidad || 0) *
          (+(item.ivaValue || 0) / 100),
        0
      )
      .toFixed(2);
  };

  /// HOOKS

  // const { handleUploadFile } = useUploadFile()

  useEffect(() => {
    clearSelectedItems(MaterialesKey.selectedItems)
    if (!isfcSolucionCosteada) {
      const auxProductosCosteados = dataSolucionCosteada?.data?.productos_costeados as MaterialTransferidoInventarioCorporativo[]
      console.log({ auxProductosCosteados })
      setAllItemsCosteados(
        auxProductosCosteados
      )
      const lengthCorrecciones = dataSolucionCosteada?.data.observaciones?.observacion_revision_supervisor?.length
      setUtltimaCorreccion(
        dataSolucionCosteada?.data.observaciones?.observacion_revision_supervisor?.[lengthCorrecciones - 1]
        || []
      )
      console.log({ allItemsCosteados })




    }
    // if(!Array.isArray(dataSolucionCosteada?.data?.detalles))
    //   return
    // dataSolucionCosteada?.data?.detalles?.forEach(element => {
    //   const precioUnitarioAux = parseFloat(element?.producto_data?.precios[0]?.precio) || 0;
    //   addSelectedItem(
    //     {
    //       codigo: element.codigo! || element.id!,
    //       nombre: element.nombre! || element.codigo!,
    //       precioUnitario: element.precioUnitario || precioUnitarioAux,
    //       cantidad: element.cantidad!,
    //       total: element.total || parseFloat(element.cantidad!)*precioUnitarioAux,
    //       ivaCode: element.ivaCode || "IVA 0%",
    //       ivaValue: element.ivaValue || 0, // 15% de 50
    //       precioLibre: element.precioLibre || true,
    //       preciosDisponibles: element.preciosDisponibles || element?.producto_data?.precios,
    //     },
    //     MaterialesKey.selectedItems, 'codigo', false, false
    //   );
    // });
    // // console.log({selectedItems})







    // //VALORES DE PLAN
    // const planChoosed = planesCorporativosGlobal.filter(x=>x.codigo==dataSolucionCosteada?.data?.preventa_corporativa_data?.plan)
    // console.log({planChoosed})
    // //Se añadenValores de Plan
    // const ValoresPlan : MaterialTransferido[] = []
    // ValoresPlan.push({
    //   codigo:dataSolucionCosteada?.data?.preventa_corporativa_data?.plan!,
    //   nombre:planChoosed[0].nombre||"PLAN DE PRUEBA",
    //   precioUnitario:dataSolucionCosteada?.data.preventa_corporativa_data?.valor_plan,
    //   cantidad:1,
    //   total:dataSolucionCosteada?.data.preventa_corporativa_data?.valor_plan,
    //   ivaValue:0,
    //   ivaCode:""
    // })
    // ValoresPlan.push({
    //   codigo:dataSolucionCosteada?.data?.preventa_corporativa_data?.plan+"-instalacion",
    //   nombre:"VALOR DE INSTALACIÓN",
    //   precioUnitario:dataSolucionCosteada?.data.preventa_corporativa_data?.valor_instalacion,
    //   cantidad:1,
    //   total:dataSolucionCosteada?.data.preventa_corporativa_data?.valor_instalacion,
    //   ivaValue:0,
    //   ivaCode:""
    // })
    // console.log({ValoresPlan})
    // setValoresPlanesCorporativos(ValoresPlan)


    // //añadir validacion para servicios que vayan a manejar valores
    // const ValoresServiciosAdicionales : MaterialTransferido[] = []
    // if(dataSolucionCosteada?.data?.preventa_corporativa_data?.seguridad_perimetral){
    //   ValoresServiciosAdicionales.push({
    //     codigo:"SEGURIDAD_PERIMETRAL",
    //     nombre:"SEGURIDAD PERIMETRAL",
    //     precioUnitario:dataSolucionCosteada?.data.preventa_corporativa_data?.costo_seguridad_perimetral,
    //     cantidad:1,
    //     total:dataSolucionCosteada?.data.preventa_corporativa_data?.costo_seguridad_perimetral,
    //     ivaValue:0,
    //     ivaCode:""
    //   })
    // }
    // if(dataSolucionCosteada?.data?.preventa_corporativa_data?.wifi_gestionado){
    //   ValoresServiciosAdicionales.push({
    //     codigo:"WIFI_GESTIONADO",
    //     nombre:"WIFI GESTIONADO",
    //     precioUnitario:dataSolucionCosteada?.data.preventa_corporativa_data?.costo_wifi_gestionado,
    //     cantidad:1,
    //     total:dataSolucionCosteada?.data.preventa_corporativa_data?.costo_wifi_gestionado,
    //     ivaValue:0,
    //     ivaCode:""
    //   })
    // }
    // if(dataSolucionCosteada?.data?.preventa_corporativa_data?.cableado_interno){
    //   ValoresServiciosAdicionales.push({
    //     codigo:"CABLEADO_INTERNO",
    //     nombre:"CABLEADO INTERNO",
    //     precioUnitario:dataSolucionCosteada?.data.preventa_corporativa_data?.costo_cableado_interno,
    //     cantidad:1,
    //     total:dataSolucionCosteada?.data.preventa_corporativa_data?.costo_cableado_interno,
    //     ivaValue:0,
    //     ivaCode:""
    //   })
    // }
    // if(dataSolucionCosteada?.data?.preventa_corporativa_data?.equipos_adicionales && 
    //   dataSolucionCosteada?.data?.preventa_corporativa_data?.equipos_adicionales?.length>0
    // ){
    //   dataSolucionCosteada?.data?.preventa_corporativa_data?.equipos_adicionales?.map((x)=>{
    //     ValoresServiciosAdicionales.push({
    //       codigo: x.codigo,
    //       nombre: x.codigo,
    //       precioUnitario:parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
    //       cantidad:1,
    //       total:parseFloat(x.producto_data?.precios?.[0]?.precio || "0"),
    //       ivaValue:0,
    //       ivaCode:""
    //     })
    //   })
    // }
    // setValoresServiciosAdicionalesCorporativos(ValoresServiciosAdicionales)











  }, [isfcSolucionCosteada]);

  ///COLUMNS
  // const columnsRevisionProductosContabilidad = useMemo<
  // MRT_ColumnDef<MaterialTransferido>[]
  // >(
  //   () => [
  //     {
  //       accessorKey: 'nombre',
  //       header: 'Nombre',
  //       size: 300,
  //     },
  //     {
  //       accessorKey: 'precioUnitario',
  //       header: 'Precio',
  //       size: 120,
  //     },
  //     {
  //       accessorKey: 'ivaCode',
  //       header: 'Imp %',
  //       size: 100,
  //     },
  //     {
  //       accessorKey: 'cantidad',
  //       header: 'Cantidad',
  //       size: 120,
  //     },
  //     {
  //       accessorKey: 'total',
  //       header: 'Sub-Total',
  //       size: 120,
  //     },
  //   ],
  //   []
  // );

  const columnasNoModificables = useMemo<
    MRT_ColumnDef<MaterialTransferidoInventarioCorporativo>[]
  >(
    () => [
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'precioUnitario',
        header: 'Precio',
        size: 120,
        Cell: ({ row }) => row.original.precioUnitario || 0,
      },
      {
        accessorKey: 'cantidad',
        header: 'Cantidad',
        size: 120,
      },
      {
        accessorKey: 'ivaCode',
        header: 'Imp %',
        size: 100,
        Cell: ({ row }) => {
          console.log(row.original)
          return row.original.ivaCode || "0%"
        }
      },
      {
        accessorKey: 'incremento',
        header: 'Incremento',
        size: 100,
        Cell: ({ row }) => `${row.original?.incremento || "0"}%`
      },
      {
        accessorKey: 'subtotal',
        header: 'Sub-Total',
        size: 120,
      },
      {
        accessorKey: 'total',
        header: 'Total',
        size: 120,
      },
    ],
    []
  );

  useEffect(() => {
    form.reset({
      ...form.getValues(),
      "documentos_habilitantes": dataSolucionCosteada?.data?.documentos?.documentos_habilitantes,
    })
    form2.reset({
      ...form2.getValues(),
      "documentos_contractuales": dataSolucionCosteada?.data?.documentos?.documentos_contractuales,
    })
  }, [])

  useLoaders(isfcSolucionCosteada)
  if (isfcSolucionCosteada) return null

  return (
    <>
      <Typography variant="h5">
        Solución costeada **
      </Typography>
      <Typography variant="h3">
        {dataSolucionCosteada?.data?.prospecto_corporativo_data?.razon_social}
      </Typography>
      <Typography variant="h5">
        Identificación: {dataSolucionCosteada?.data?.prospecto_corporativo_data?.identificacion}
      </Typography>
      <Typography variant="caption">{
        dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta ?
          `Condición Venta: ${dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta}`
          : undefined
      }</Typography>

      <Grid container spacing={3} mt={2} mb={1}>
        {/* ================== button popover ================== */}
        {/* <ClienteRubroLibrePopover contract={contract} form={form} /> */}
        <Grid xs={12} md={12} container justifyContent="flex-end">
          {
            (dataSolucionCosteada?.data.revisado_supervisor == true
              && dataSolucionCosteada?.data.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_REVISION
              && !dataSolucionCosteada?.data.aprobado_supervisor
              && (!!!dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta
                || dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta == CondicionVentaCorporativa.EVENTO_PAGADO)
            )
              // ||
              // (
              //   !!dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta
              //   && (!dataSolucionCosteada?.data?.url_anexo_1 || !dataSolucionCosteada?.data?.url_anexo_2)
              // )
              ||
              (
                !!dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta
                && dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta != CondicionVentaCorporativa.EVENTO_PAGADO
              )
              ?
              <Tooltip title="Subir Documentos">
                <Button
                  onClick={() => {
                    setOpenUploadDocuments(!openUploadDocuments)
                  }}
                  style={{
                    color: '#2F3746'
                  }}
                  startIcon={<ContentCopyIcon />}
                >
                  <span style={{ fontSize: "12px" }}>Documentos</span>

                </Button>

              </Tooltip>
              : null
          }
          <Button
            onClick={() => {
              navigate(returnUrl)
            }}
            variant="outlined"
            sx={{
              py: 1,
              my: 0,
              marginX: 1
            }}
            size="small"
          >
            Regresar
          </Button>
          {
            dataSolucionCosteada?.data.estado_factibilidad == EstadoFactibilidadCorporativaENUM.APROBADO
              && dataSolucionCosteada?.data.revisado_supervisor
              && dataSolucionCosteada?.data.aprobado_inventario
              && !dataSolucionCosteada?.data.factibilidad_enviada ?
              <Button
                onClick={() => {
                  onSend()
                }}
                variant="outlined"
                sx={{
                  py: 1,
                  my: 0,
                  marginX: 1
                }}
                size="small"
                color="success"
              >
                Enviar Agendamiento
              </Button>
              : null
          }
          {
            dataSolucionCosteada?.data.factibilidad_enviada ?
              <Button
                variant="outlined"
                sx={{
                  py: 1,
                  my: 0,
                  marginX: 1
                }}
                size="small"
                color="success"
                disabled={true}
              >
                Enviada a Agendamiento
              </Button>
              : null
          }
          {/* 
          // ===================================================================
          // Botones solo habilitados para los procesos con condición de venta
          //  No pasan por supervisor
          // ===================================================================
           */}
          {
            (
              // dataSolucionCosteada?.data.prospecto_corporativo_data?.requiere_cotizacion
              // && dataSolucionCosteada?.data.revisado_contabilidad
              dataSolucionCosteada?.data.preaprobado_inventario
              && dataSolucionCosteada?.data.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_GESTION
              && dataSolucionCosteada?.data?.prospecto_corporativo_data?.condicion_venta
              && dataSolucionCosteada?.data?.prospecto_corporativo_data?.condicion_venta != CondicionVentaCorporativa.EVENTO_PAGADO
            )
              ||
              (
                !dataSolucionCosteada?.data.prospecto_corporativo_data?.requiere_cotizacion
                && dataSolucionCosteada?.data.preaprobado_inventario
                && dataSolucionCosteada?.data.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_GESTION
                && dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta == CondicionVentaCorporativa.CANJE
              ) ?
              <>
                <Button
                  variant="outlined"
                  onClick={() => rechazarSolucion()}
                  sx={{
                    py: 1,
                    my: 0,
                    marginX: 1
                  }}
                  size="small"
                  color="error"
                >
                  Rechazar
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => solicitarAprobacionInventario()}
                  sx={{
                    py: 1,
                    my: 0,
                    marginX: 1
                  }}
                  size="small"
                  color="success"
                >
                  Solicitar Aprobación Inventario
                </Button>
              </>
              : null
          }

        </Grid>
        {/* ================== Novedades con Documentos ================== */}
        {
          dataSolucionCosteada?.data.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_REVISION
            && dataSolucionCosteada?.data.revisado_supervisor
            && dataSolucionCosteada?.data.observaciones?.observacion_revision_supervisor?.length > 0 ?
            <Grid item {...gridSizeMdLg12} justifyContent={"left"} textAlign={"left"}>
              <Typography variant="h6">Inconvenientes Presentados</Typography>
              <Grid>
                <Grid>
                  <span><b>Motivo: </b></span>
                  <span>{utltimaCorreccion?.motivo_rechazo || "N/A"}</span>
                </Grid>
                <Grid>
                  <span><b>Observación: </b></span>
                  <span>{utltimaCorreccion?.observacion_cancelacion || "N/A"}</span>
                </Grid>
                <Grid>
                  <span><b>Fecha: </b></span>
                  <span>{dayjs(utltimaCorreccion?.fecha).format("LLL") || "N/A"}</span>
                </Grid>

              </Grid>
            </Grid>
            : null
        }
        {/* 
        ================== Upload Documents ================== 
        // =====================================================================
        // Muestro documentos en dos casos:
        //  1- en el flujo normal, donde no hay una condición de venta
        //  2- en el flujo corporativo, dejo habilitado la carga de documentos cuando sea canje
        //  y no se hayan subido los dos documentos necesario para esta sección
        // =====================================================================
        */}
        {
          (dataSolucionCosteada?.data.revisado_supervisor
            && dataSolucionCosteada?.data.estado_factibilidad == EstadoFactibilidadCorporativaENUM.EN_REVISION
          )
            ||
            (dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta == CondicionVentaCorporativa.CANJE
              && (!dataSolucionCosteada?.data?.url_anexo_1 || dataSolucionCosteada?.data?.url_anexo_2)
            )
            ||
            (
              dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta == CondicionVentaCorporativa.EVENTO_PAGADO
            )
            ?
            <Grid container item xs={12}
              justifyContent={'center'}
              spacing={2}
              sx={{
                display:
                  openUploadDocuments
                    ? "flex" : "none",
              }}
            >

              {/* <Grid item {...gridSizeMdLg3}>
                <IconButton onClick={() => {
                  // setOpenUploadDocuments(true)
                }}>
                  <InsertDriveFileIcon />
                  <span style={{ fontSize: "12px" }}>Cargar Documento</span>
                </IconButton>
              </Grid> */}

              {/* <Grid item xs={12}>
                <Typography variant="h6" p={2}>
                  Carga de Documentos
                </Typography>
                <TabTextLabel text="Si ya ha cargado los documentos previamente, realizar esta acción reemplazará los anteriores."/>

              </Grid> */}



              <Grid item {...gridSizeMdLg6}>
                <DropzoneFiles form={form} titleCargaAnexos="Documentos Habilitantes"
                  sizeItem={gridSizeConst3} titleButtonSave="Guardar Documentos Habilitantes"
                  keyForm="documentos_habilitantes" bucket={BucketAwtENUM.DOCUMENTOS_SOLUCION_COSTEADA_CORPORATIVA} />
                {/* <CargaDocumentosSolucionCosteadaMultiple form={form} size={gridSizeMdLg12}
                currentKeyForm="documentos_habilitantes"/> */}
                {/* <CargarDocumentoSoluccionCosteada
                  idInput='anexo-1'
                  buttonText={'Documentos Habilitantes'}
                  selectedImage={docAnexo1}
                  setSelectedImage={setDocAnexo1}

                /> */}
              </Grid>

              <Grid item {...gridSizeMdLg6}>
                <DropzoneFiles form={form2} titleCargaAnexos="Documentos Contractuales"
                  sizeItem={gridSizeConst3} titleButtonSave="Guardar Documentos Contractuales"
                  keyForm="documentos_contractuales" bucket={BucketAwtENUM.DOCUMENTOS_SOLUCION_COSTEADA_CORPORATIVA} />
                {/* <CargaDocumentosSolucionCosteadaMultiple form={form} 
                size={gridSizeMdLg12} currentKeyForm="documentos_contractuales"/> */}
                {/* <CargarDocumentoSoluccionCosteada
                  idInput='anexo-2'
                  buttonText={'Documentos Contractuales'}
                  selectedImage={docAnexo2}
                  setSelectedImage={setDocAnexo2}
                /> */}
              </Grid>


              <Grid item {...gridSizeMdLg12} justifyContent={"center"} textAlign={"end"}>
                <Button
                  onClick={async () => {

                    console.log('dataCosteada', dataSolucionCosteada?.data.prospecto_corporativo_data)
                    
                    //return 
                    const documentos_habilitantes = form.getValues()?.documentos_habilitantes
                    const documentos_contractuales = form2.getValues()?.documentos_contractuales

                    ///* Documentos pendientes por subir
                    if (!documentos_habilitantes || documentos_habilitantes.length === 0
                      || !documentos_contractuales || documentos_contractuales.length === 0)
                      return setAlert(true, 'Suba al menos un documento en cada campo', AlertSeverityEnum.info)

                    const sendDocumentos = {
                      documentos_habilitantes: documentos_habilitantes,
                      documentos_contractuales: documentos_contractuales
                    }

                    try {

                      if (sendDocumentos.documentos_habilitantes && sendDocumentos.documentos_contractuales) {
                        // =====================================================
                        // una vez cargados los documentos no se puede editar la información de la preventa
                        // =====================================================
                        mutateAsyncPutPreventaCorporativo({
                          id_preventa_coorporativa: dataSolucionCosteada.data.preventa_corporativa_data?.id_preventa_coorporativa,
                          permitir_edicion: false
                        })
                        // =====================================================
                        // si es una venta de canje se guardan solo las urls
                        // =====================================================
                        if (dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta == CondicionVentaCorporativa.CANJE) {
                          updateFCorporativa({
                            documentos: sendDocumentos,
                            id_factibilidad_coorporativa: dataSolucionCosteada?.data.id_factibilidad_coorporativa,
                          })
                        } else {
                          updateFCorporativa({
                            documentos: sendDocumentos,
                            id_factibilidad_coorporativa: dataSolucionCosteada?.data.id_factibilidad_coorporativa,
                            estado_factibilidad: dataSolucionCosteada?.data.observaciones?.observacion_revision_supervisor?.length > 0 ?
                              EstadoFactibilidadCorporativaENUM.CORREGIDO
                              : EstadoFactibilidadCorporativaENUM.DOCUMENTOS_CARGADOS
                          })
                        }
                      } else {
                        return setAlert(true, 'Error al cargar los documentos. Intente nuevamente.', AlertSeverityEnum.warning)
                      }

                    } catch (error) {

                      return setAlert(true, 'Error al cargar los documentos', AlertSeverityEnum.error)

                    }
                  }}
                  variant="outlined"
                  sx={{
                    py: 1,
                    my: 0,
                    marginX: 1
                  }}
                  size="small"
                  color="primary"
                >
                  {
                    dataSolucionCosteada?.data.prospecto_corporativo_data?.condicion_venta ?
                      "Cargar Documentos"
                      :
                      "Enviar Documentos a Revisión"
                  }
                </Button>
              </Grid>
            </Grid>
            : null
        }

        {/* ================== items equipos adicionales table ================== */}
        <Grid item xs={12}>
          <Typography variant="h6" p={2}>
            Materiales y Equipos de Instalación
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnasNoModificables}
            data={
              allItemsCosteados?.
                filter((x: MaterialTransferidoInventarioCorporativo) =>
                  x.categoria_fcorporativa == CategoriaFCorporativaEnum.MATERIALESEQUIPOS
                )
              || []
            }
          // isLoading={isfcSolucionCosteada}
          />

        </Grid>

        {/* ================== items servicios adicionales table ================== */}
        <Grid item xs={12}>
          <Typography variant="h3" p={2}>
            Detalles
          </Typography>
          <Typography variant="h6" p={2}>
            Equipos Adicionales
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnasNoModificables}
            data={
              allItemsCosteados?.
                filter((x: MaterialTransferidoInventarioCorporativo) =>
                  x.categoria_fcorporativa == CategoriaFCorporativaEnum.EQUIPOSADICIONALES
                )
              || []
            }
          />
        </Grid>
        {/* ================== items servicios adicionales table ================== */}
        <Grid item xs={12}>
          <Typography variant="h6" p={2}>
            Materiales y Equipos Solicitados
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnasNoModificables}
            data={
              allItemsCosteados?.
                filter((x: MaterialTransferidoInventarioCorporativo) =>
                  x.categoria_fcorporativa == CategoriaFCorporativaEnum.SERVICIOSADICIONALES
                  && x.producto_data
                )
              || []
            }
          // isLoading={isfcSolucionCosteada}
          />
        </Grid>
        {/* ================== items servicios adicionales table ================== */}
        <Grid item xs={12}>
          <Typography variant="h6" p={2}>
            Servicios Adicionales
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnasNoModificables}
            data={
              allItemsCosteados?.
                filter((x: MaterialTransferidoInventarioCorporativo) =>
                  x.categoria_fcorporativa == CategoriaFCorporativaEnum.SERVICIOSADICIONALES
                  && !x.producto_data
                )
              || []
            }
          />
        </Grid>

        {/* ================== items valores del plan table ================== */}
        <Grid item xs={12}>
          <Typography variant="h6" p={2}>
            Valores del Plan
          </Typography>
          <SampleTable<MaterialTransferidoInventarioCorporativo>
            columns={columnasNoModificables}
            data={allItemsCosteados?.filter((x: MaterialTransferidoInventarioCorporativo) => x.categoria_fcorporativa == CategoriaFCorporativaEnum.VALORESPLAN) || []}
          // isLoading={isfcSolucionCosteada}
          />
        </Grid>





        {/* <Grid item xs={12}>
          <SampleTable<MaterialTransferido>
            columns={columnsRevisionProductosContabilidad}
            data={selectedItems}
            isLoading={isfcSolucionCosteada}
          />
        </Grid> */}

        {/* ================== total ================== */}
        <TotalAmountRubloLireCard
          calcSubTotal={calcSubTotal}
          calcTotalTaxes={calcTotalTaxes}
          calcTotal={calcTotal}
        />

        {/* PRV-002: Sección Información Adicional (Solo Lectura) */}
        {(dataSolucionCosteada?.data?.area_responsable_inspeccion || dataSolucionCosteada?.data?.url_archivo_inspeccion_adicional) && (
          <Grid item xs={12} sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{
              borderBottom: '2px solid #1976d2',
              paddingBottom: 1,
              marginBottom: 2
            }}>
              Información Adicional
            </Typography>
            <Grid container spacing={2}>
              {dataSolucionCosteada?.data?.area_responsable_inspeccion && (
                <Grid item xs={12} md={6}>
                  <Typography variant="body1">
                    <strong>Área Responsable:</strong> {dataSolucionCosteada.data.area_responsable_inspeccion}
                  </Typography>
                </Grid>
              )}
              {dataSolucionCosteada?.data?.url_archivo_inspeccion_adicional && (
                <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                  <a
                    target="_blank"
                    href={dataSolucionCosteada.data.url_archivo_inspeccion_adicional}
                    rel="noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'primary.main',
                        textDecoration: 'underline',
                        cursor: 'pointer'
                      }}
                    >
                      Ver/Descargar Documento de Inspección
                    </Typography>
                  </a>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {/* FIN PRV-002 */}

      </Grid>
    </>
    // <SingleTableBoxScene
    //   title="Solución Costeada"
    //   // urlRedirect={`${ROUTER_PATHS.ventasCorporativas.capacidadCorporativaCrearNav}`}
    //   // enableRedirect={hasPermission(PermissionsEnum.api_add_capacidadcoorporativa)}
    // >
    //   <GeneralTable<IFactibilidadCorporativo>
    //     columns={columnsSolucionCosteada}
    //     data={dataSolucionCosteada?.data?.data || []}
    //     //
    //     isLoading={isLoadingFactCoorporativa}
    //     isRefetching={isRefetchingFactCoorporativa}
    //     // // search
    //     enableGlobalFilter={false}
    //     // // filters - llega al back
    //     enableManualFiltering={true}
    //     columnFilters={columnFilters}
    //     onColumnFiltersChange={setColumnFilters}
    //     enableSorting={false}
    //     // // pagination
    //     pagination={pagination}
    //     onPaging={setPagination}
    //     rowCount={dataSolucionCosteada?.data?.count}
    //     // // actions ========
    //     enableColumnActions={hasPermission(PermissionsEnum.api_change_capacidadcoorporativa)}
    //     actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
    //     positionActionsColumn="first"
    //     // crud
    //     canEdit={hasPermission(PermissionsEnum.api_change_capacidadcoorporativa)}
    //     onEdit={(value) => {
    //       navigate(`${ROUTER_PATHS.ventasCorporativas.capacidadCorporativaEditarNav}/${value.id_factibilidad_coorporativa}`)
    //     }}
    //     canDelete={false}
    //   />
    // </SingleTableBoxScene>
  );

}